import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PriceData } from './price.types';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PriceService {
  rootUrl = 'https://appgw.prod.iktest.co/api-app/price';

  constructor(private _httpClient: HttpClient) {}

  // Current month, day resolution
  getPrices(objectid: string): Observable<PriceData[]> {
    const path = `${this.rootUrl}/${objectid}`;
    return this._httpClient.get<PriceData[]>(path);
  }

  // Hour resolution
  getPricesHourPeriod(
    objectid: string,
    period: string // YYYY | YYYYMM | YYYYMMDD
  ): Observable<PriceData[]> {
    const path = `${this.rootUrl}/${objectid}/${period}/H`;
    return this._httpClient.get<PriceData[]>(path);
  }

  // Day resolution
  getPricesDayPeriod(
    objectid: string,
    period: string // YYYY | YYYYMM | YYYYMMDD
  ): Observable<PriceData[]> {
    const path = `${this.rootUrl}/${objectid}/${period}/D`;
    return this._httpClient.get<PriceData[]>(path);
  }

  // Month resolution
  getPricesMonthPeriod(
    objectid: string,
    period: string // YYYY | YYYYMM | YYYYMMDD
  ): Observable<PriceData[]> {
    const path = `${this.rootUrl}/${objectid}/${period}/M`;
    return this._httpClient.get<PriceData[]>(path);
  }
}
